import type { Color } from 'src/types/theme';

export const red: Color = {
  50: '#ffefef',
  100: '#ffd8d7',
  200: '#ed9f9c',
  300: '#e77d79',
  400: '#e15c57',
  500: '#db3a34',
  600: '#c32923',
  700: '#97191e',
  800: '#641512',
  900: '#340b09',
};
